module.exports = __webpack_public_path__ + "static/media/social_icon_facebook.992008ad.svg";